import {IMiniOrbitCommunicationAdapter} from '../mini-orbit-communication-adapter.interface';
import {IServiceFactoryExtended} from '../../../service-factory-extended.interface';
import {Check} from '@sparkware/app-utils';
import {IAutoLoginParams} from '../../../../../common/interfaces/autologin-params.interface';

export const POKER_COMMUNCATION_OBJECT_NAME = 'pokerNativeInterface';

export class PokerCommunicationAdapter implements IMiniOrbitCommunicationAdapter {
    constructor(private services: IServiceFactoryExtended) {

    }

    private get _pokerCommunicationObject(): any {
        const adapter = this.services.window.getGlobalProperty(POKER_COMMUNCATION_OBJECT_NAME);
        if(!adapter) {
            this.services.logger.error(`${POKER_COMMUNCATION_OBJECT_NAME} adapter is not defined`);
        }
        return adapter;
    }

    onUserKicked(logoutReason: number|null): Promise<IAutoLoginParams>{
        if(this._pokerSupportsSoftLogin)
        {
            return this._pokerCommunicationObject?.onUserKicked(logoutReason);
        }
        else
        {
            this._pokerCommunicationObject?.kickUser();
            return Promise.resolve(null);
        }
    }

    openUrlInExternalBrowser = (url: string): void => {
        this._pokerCommunicationObject?.openUrlInExternalBrowser(url);
    };

    private get _pokerSupportsSoftLogin():boolean
    {
        return Check.isFunction(this._pokerCommunicationObject?.onUserKicked);
    };

    onSiteLoaded(): void {
        try {
      if(Check.isFunction(this._pokerCommunicationObject?.onSiteLoaded)) {
          this._pokerCommunicationObject.onSiteLoaded();
      } else {
          this.services.logger.warning(`${POKER_COMMUNCATION_OBJECT_NAME}.onSiteLoaded is missing`);
      }
        }catch (e) {
            this.services.logger.error("PokerCommunicationAdapter onSiteLoaded error : "+e);
        }
    }

    onAutologinSuccess(): void{
        try {
            if(Check.isFunction(this._pokerCommunicationObject?.onAutologinSuccess)) {
                this._pokerCommunicationObject.onAutologinSuccess();
            } else {
                this.services.logger.warning(`${POKER_COMMUNCATION_OBJECT_NAME}.onAutologinSuccess is missing`);
            }
        }catch (e) {
            this.services.logger.error("PokerCommunicationAdapter onAutologinSuccess error : "+e);
        }

    }

    onAutologinFailed(): void{
        if(Check.isFunction(this._pokerCommunicationObject?.onAutologinFailed)) {
            this._pokerCommunicationObject.onAutologinFailed();
        } else {
            this.services.logger.warning(`${POKER_COMMUNCATION_OBJECT_NAME}.onAutologinFailed is missing`);
        }
    }

    openControlCenter(): void { }
}
